import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject, EMPTY } from 'rxjs';
import { catchError, filter, take, switchMap, finalize } from 'rxjs/operators';
import { TokenService } from '@core/services/token.service';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { backToGuest } from '@core/store/actions/login.actions';
@Injectable({ providedIn: 'root' })
export class RefreshTokenInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );
  constructor(
    public tokenService: TokenService,
    private router: Router,
    private store: Store
  ) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const isWhiteList =
      request.url.includes('/Login') ||
      request.url.includes('/Home') ||
      request.url.includes('/LoginWithSocialMedia') ||
      request.url.includes('/Register') ||
      request.url.includes('/VerifyActivationCode') ||
      request.url.includes('/RefreshToken') ||
      request.url.includes('/GetAppSettings') ||
      request.url.includes('/ForgotPasswordByEmail') ||
      request.url.includes('/ForgotPasswordByMobile') ||
      request.url.includes('/ResetPassword') ||
      request.url.includes('/SendActivationCode') ||
      request.url.includes('/en.json') ||
      request.url.includes('/ar.json') ||
      request.url.includes('/ContinueAsGuest');
    const refresh = this.tokenService.getRefreshToken();
    if (!refresh && !isWhiteList) {
      // Redirect to the login page if there's no refresh token
      this.router.navigate(['/login']);
      return throwError('----------');
    }
    if (this.tokenService.isTokenExpired() && !isWhiteList) {
      // console.log('********************* token expired **********************');
      // If the token is not valid, try to refresh it before making the request
      return this.handle401Error(request, next);
    }
    if (refresh && this.isRefreshing) {
      request = this.addToken(request, this.tokenService.getRefreshToken());
    }
    return next.handle(request).pipe(
      catchError((error) => {
        if (
          error instanceof HttpErrorResponse &&
          error.status === 401 &&
          !this.isRefreshing
        ) {
          return this.handle401Error(request, next);
        } else {
          return throwError(error);
        }
      })
    );
  }
  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      // console.log('refresh token 401');
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.tokenService.refreshToken().pipe(
        catchError((err) => {
          this.store.dispatch(
            backToGuest({ payload: { redirectToLogin: true } })
          );
          this.router.navigate(['/login']).then();
          return EMPTY;
        }),
        switchMap((res) => {
          this.isRefreshing = false;
          this.refreshTokenSubject.next(res.Customer?.Token);
          return next.handle(this.addToken(request, res.Customer?.Token));
        }),
        finalize(() => (this.isRefreshing = false))
      );
    } else {
      return this.refreshTokenSubject.pipe(
        filter((token) => token != null),
        take(1),
        switchMap((token) => {
          return next.handle(this.addToken(request, token));
        })
      );
    }
  }
}
